import { fetchApi } from '@/config/axiosSetting.ts';

import {
  DownloadZipVehiclePicturesQueryResponseType,
  DownloadZipVehiclePicturesZipType,
} from '@/modules/FileDetail/queries/documentation/downloadZip/downloadZipVehiclePictures/downloadZipVehiclePicturesQuery.type';

export const downloadZipVehiclePicturesQueryFunction = ({
  id,
}: DownloadZipVehiclePicturesZipType): Promise<DownloadZipVehiclePicturesQueryResponseType> =>
  fetchApi.get(`documents/${id}/file_images_zip/download/`);
